export type TelemetryLevel = 'info' | 'warn' | 'error';

export interface TelemetryEvent {
  level: TelemetryLevel;
  eventType: string;
  message: string;
  details?: Record<string, unknown>;
}

function emitToConsole(event: TelemetryEvent): void {
  const payload = {
    ...event,
    timestamp: new Date().toISOString(),
    source: 'devsecops-frontend',
  };

  const line = JSON.stringify(payload);

  if (event.level === 'error') {
    // eslint-disable-next-line no-console
    console.error(line);
  } else if (event.level === 'warn') {
    // eslint-disable-next-line no-console
    console.warn(line);
  } else {
    // eslint-disable-next-line no-console
    console.log(line);
  }
}

export function trackEvent(event: TelemetryEvent): void {
  emitToConsole(event);
}
